module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/land-7d6e2abcd504072546e61110b600502a.svg";